<template>
  <div v-if="isLoading" class="loading-container">
    <div class="line" v-for="n in 5" :key="n"></div>
  </div>
</template>

<script>
export default {
  name: "LoadingAnimation",
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    isLoading(newVal) {
      if (!newVal) {
        this.stopAnimation();
      }
    }
  },
  methods: {
    stopAnimation() {
      const lines = document.querySelectorAll(".line");
      lines.forEach((line) => {
        line.style.animation = "none";
        line.offsetHeight; // Trigger reflow to restart animation
        line.style.animation = null; // Re-enable animation
      });
    }
  }
};
</script>

<style scoped>
@keyframes shrink {
  0%,
  100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0);
  }
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
}

.line {
  width: 4px;
  height: 100px;
  margin: 0 2px;
  background-color: #d73f09;
  animation: shrink 1s infinite ease-in-out;
  animation-direction: alternate;
  animation-delay: calc(0.1s * var(--i));
}

.line:nth-child(1) {
  --i: 0;
}

.line:nth-child(2) {
  --i: 1;
}

.line:nth-child(3) {
  --i: 2;
}

.line:nth-child(4) {
  --i: 3;
}

.line:nth-child(5) {
  --i: 4;
}
</style>
